import { Injectable } from "@angular/core";
import { RateAction, RateInfo } from "../../interfaces/rate.interface";
import { LoggingService } from "../log.service";
import { RestfulService } from "../restful.service";
import { RequestBody } from "../../interfaces/admin.interface";
import { Observable } from "rxjs";
import { getEndPointWithParams } from '../../../../assets/js/util.js';
import * as ENDPOINT from "../../../shared/constant/endPoint.js";
import { HttpResponse } from "@angular/common/http";
import { UtilsService } from "../utils.service";

@Injectable({
    providedIn: 'root'
})
export class RateService {
    typeActionRate: RateAction;

    constructor(
        private logger: LoggingService,
        private restful: RestfulService,
        private utils: UtilsService
    ) { }

    setTypeActionRate(rateAction: RateAction) {
        this.typeActionRate = rateAction;
    }

    getTypeActionRate(): RateAction {
        return this.typeActionRate;
    }

    getRatesList(reqBody: RequestBody): Observable<any> {
        const endPoint = ENDPOINT.rate_all;
        return this.post(endPoint, reqBody);
    }

    getRateInfo(rateId: number): Observable<any> {
        const endPoint = getEndPointWithParams(ENDPOINT.rate_info, rateId);
        return this.get(endPoint);
    }

    createRate(reqBody: RateInfo): Observable<any> {
        return this.post(ENDPOINT.rate_create, reqBody);
    }

    editRate(reqBody: RateInfo): Observable<any> {
        const endPoint = getEndPointWithParams(ENDPOINT.rate_update);
        return this.post(endPoint, reqBody);
    }

    duplicateRate(rateId: number): Observable<any> {
        const endPoint = getEndPointWithParams(ENDPOINT.rate_duplicate, rateId);
        return this.get(endPoint);
    }

    toggleRateState(rateId: string): Observable<any> {
        const endPoint = getEndPointWithParams(ENDPOINT.rate_toggle, rateId);
        return this.put(endPoint);
    }

    /* RESTFUL METHOD */

    post(endPoint: string, reqBody: any, localhost: boolean = false): Observable<any> {
        return Observable.create((observer: any) => {
            this.restful.post(endPoint, reqBody).subscribe((response: any) => {
                this.responseHandler(response, observer);
            });
        });
    }

    put(endPoint: string): Observable<any> {
        return Observable.create((observer: any) => {
            this.restful.put(endPoint, null).subscribe((response: any) => {
                this.responseHandler(response, observer);
            });
        });
    }

    delete(endPoint: string): Observable<any> {
        return Observable.create((observer: any) => {
            this.restful.delete(endPoint).subscribe((response: any) => {
                this.responseHandler(response, observer);
            });
        });
    }

    get(endPoint: string): Observable<any> {
        return Observable.create((observer: any) => {
            this.restful.get(endPoint).subscribe((response: any) => {
                this.responseHandler(response, observer);
            });
        });
    }

    responseHandler(response: HttpResponse<any>, observer: any): void {
        const outcome = response["outcome"];
        if (outcome.success === true) {
            this.logger.log("Service:", "SUCCESS", 200);
            observer.next(response);
        } else {
            this.logger.log("Service:", "FAILURE", 200);
            outcome.message = this.utils.manageErrorMsg(outcome);
            observer.error(outcome);
        }
    }

}
